import { formatDate, formatDateTime } from "@/utils/date.js";
import { mapActions, mapState, mapGetters } from "vuex";
import dialogImg from "@/im/components/dialog-img";
import CustomItem from "@/im/components/custom-item.vue";
import moment from 'moment';
import { imageUpload } from "@/api/im";
import {commonData} from "@/shared-services";
import {systemInfo} from "@/shared-services";
import { userService$ } from '@/shared-services'

export default {
  components: { dialogImg, CustomItem },
  props: ["chatItem", "segmentationTime", "Index", "pushTime", "list", 'deepList'],
  data() {
    return {
      isDownImg: false,
      cloneImg: false,
      isTurnOnAudio: false,
      whiteSpace: false,
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      havaRead: require("@/assets/img/chat-icon/have-read.svg"),
      unRead: require("@/assets/img/chat-icon/unread.svg"),
      faile: require("@/assets/img/chat-icon/faile.svg"),
      downRowIn: require("@/assets/img/im-icon/down-row-in.svg"),
      downRowOut: require("@/assets/img/im-icon/down-row-out.svg"),
      startRight: require("@/assets/img/im-icon/start.svg"),
      startLeft: require("@/assets/img/im-icon/start-in.svg"),
      pauseRight: require("@/assets/img/im-icon/pause-right.svg"),
      pauseLeft: require("@/assets/img/im-icon/pause-left.svg"),
      readMore: false,
      audioTime: null,
      interval: null,
      imgVisible: false,
      duration: 0,
      firstName:'',
      lastName:'',
      name: '',
      isCommand: systemInfo.isCommand ? true : false,
    };
  },
  mounted() {
    if(!this.isCommand) {
      userService$.subscribe(x => {
        this.dspTpId = x.$handler._value['tpId']
      })
    }
    commonData.getName$().subscribe(x => {
      this.firstName = x.firstName;
      this.lastName = x.lastName;
      if(!x.firstName & !x.lastName) {
        this.name = (this.isCommand ? this.userTpId : this.dspTpId) == this.author ? `${this.email}` : ''
      }else {
        this.name = `${x.firstName} ${x.lastName}`
      }
    })
    if (
      document.querySelector(".el-textarea__inner")?.value.indexOf("\n") > -1
    ) {
      this.whiteSpace = true;
    } else {
      this.whiteSpace = false;
    }
    if (this.$props.chatItem.type === 'audio') {
      let duration = this.$props.chatItem.file.dur;
      this.audioTime = duration ? duration : null;
      this.duration = duration ? duration : 0;
    }
    this.$nextTick(() => {
      if (this.$refs.msgTextR) {
        if (this.$refs.msgTextR.scrollHeight > this.$refs.msgTextR.clientHeight) {
          this.readMore = true;
        } else {
          this.readMore = false;
        }
      }
      if (this.$refs.msgTextL) {
        if (this.$refs.msgTextL.scrollHeight > this.$refs.msgTextL.clientHeight) {
          this.readMore = true;
        } else {
          this.readMore = false;
        }
      }

      if (this.$props.chatItem.type === 'audio' && !this.audioTime) {
        let mp3Audio = this.$refs.mp3Audio;
        mp3Audio.oncanplay = () => {
          this.duration = mp3Audio.duration;
          this.audioTime = Math.ceil(mp3Audio.duration) >= 60
                    ? 60
                    : Math.ceil(mp3Audio.duration)
        }
      }
    });
  },
  computed: {
    ...mapState('im', ['currentSession', 'UIControl', 'author', 'isTurnOnAudioList']),
    ...mapState('user', ['userTpId', 'email']),
    ...mapGetters("im", ["currentTeamUsersMap", 'singleMap']),
    /**
     * 60秒内的连续消息不展示时间
     */
     isContinuous() {
      // 判断是否失败及是否是最后一条
      // if (this.$props.chatItem.status === 'fail') return true;
      if (this.$props.Index === this.$props.list.length - 1) return true;
      // 判断对方是否回应，小于60s内的消息隐藏时间
      let nowItem = this.$props.list[this.$props.Index];
      let nextItem = this.$props.list[this.$props.Index + 1];
      if (nowItem.flow !== nextItem.flow
        || (nowItem.flow !== 'out' && nextItem.flow !== 'out' && nowItem.from !== nextItem.from)) return true;
      if (new Date(nextItem.time).getTime() - new Date(nowItem.time).getTime() <= 60000) return false;
      return true;
    },
    /**
     * 判断是否是第一条
     */
    isFirstMsg() {
      if (this.Index === 0) return true;
      const nowItem = this.list[this.Index];
      const prevItem = this.list[this.Index - 1];
      if (nowItem.flow === prevItem.flow && nowItem.type !== 'notification' && prevItem.type !== 'notification' && new Date(nowItem.time).getTime() - new Date(prevItem.time).getTime() <= 60000) {
        if (nowItem.flow === 'out') return false;
        else if (nowItem.from === prevItem.from) return false;
      }
      return true;
    },
    dayFirstMessage() {
      if (this.segmentationTime.find(item => item.idtimes === this.chatItem.time)) return true;
      return false;
    },
    /**
     * 播放倒计时
     */
     calcAudioTime() {
      const audioTime = Math.round(this.audioTime / 1000);

      if (audioTime >= 60) {
        return '1:00';
      }

      const minutes = Math.floor(audioTime / 60);
      const seconds = audioTime % 60;

      const formattedMinutes = minutes.toString();
      const formattedSeconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    /**
     * 判断是否展示line
     */
     showLine() {
      return (idtimes) => {
        if (idtimes === this.chatItem.time) {
          return true;
        } else {
          // 判断当前状态是否为发送失败
          if (this.chatItem.status === 'fail') {
            if (moment(new Date(this.list[this.list.length - 2].time, 'YYYY-MM-DD')) === 
            moment(new Date(this.list[this.list.length - 1].time, 'YYYY-MM-DD'))) {
              return false;
            }
          }
        }
        return false;
      }
    },
    //动态样式
    chatDirection() {
      return this.chatItem.flow === 'out' ? 'right' : 'left'
    },
    chatDirectionRight() {
      return this.chatItem.flow === 'out'
    },
    groupSpokesman() {
      let currentUser = this.currentTeamUsersMap[this.$props.chatItem.from];
      if (!currentUser) return {};
      return currentUser;
    },
    groupSystemFormatDate() {
      return formatDateTime(this.chatItem.time);
    },
    customContent() {
      const custom = this.chatItem.custom
      if (custom.extra) {
        const extra = JSON.parse(custom.extra || "{}")
        return {
          type: extra.type,
          root: extra.root,
          data: {
            id: extra.id,
            webId: extra.webId,
            stops: extra.stops,
            sendData: extra.sendData,
            tripId: extra.tripId,
            loadId: extra.loadId
          }
        }
      }
      return ''
    },
  },
  methods: {
    ...mapActions("im", [
      "srollBottom",
      "startRecordAudio",
      "stopRecordAudio",
      "playRecordAudio",
      "sendAudioMsg",
      "checkRecordAudioPremission",
      "sendCustomMsg",
      "removeUnsendMsgs",
      "messageSendError",
      "addImageUnsend",
      'resendCustomMsg',
      'sendImageMsg',
      'sendTextMsg',
      'setCurrentAudioData'
    ]),
    isContinuePlaying(data, curentAudio, type) {
      const arr = ['play', 'stop']
      if(!data.length) return
      if(data.length && type == 'show') {
        return data[0]['status'] == 'play' && data[0]['audio'] == curentAudio ? true : false
      }
      if(data.length && type == 'time') {
        return arr.includes(data[0]['status']) && data[0]['audio'] == curentAudio ? true : false
      }
    },
    audioTimeFormat(time) {
      const audioTime = Math.round(time / 1000);
      if (audioTime >= 60) {
        return '1:00';
      }
      const minutes = Math.floor(audioTime / 60);
      const seconds = audioTime % 60;

      const formattedMinutes = minutes.toString();
      const formattedSeconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    dynamicStyle(data) {
      const duration = data.file.dur
      if (!duration) return `width: 80px`;
      let num = Math.floor(duration / 1000)
      if (num >= 0 && num <= 5) {
        return `width:${92 - 32}px`;
      } else if (num > 5 && num <= 10) {
        return `width: ${122 - 32}px`;
      } else if (num >= 11 && num <= 20) {
        return `width:${152 - 32}px`;
      } else if (num >= 21 && num <= 30) {
        return `width:${182 - 32}px`;
      } else if (num >= 31 && num <= 40) {
        return `width:${212 - 32}px`;
      } else if (num >= 41 && num <= 50) {
        return `width:${242 - 32}px`;
      } else if (num >= 51 && num <= 60) {
        return `width:${272 - 32}px`;
      }
      return 'width: 80px';
    },
    time(time) {
      return formatDate(time);
    },
    isTypeText(type, data) {
      if(['audio', 'image'].includes(type)) {
        return true
      }else {
        return data == '' ? false : true
      }
    },
    downloadByBlob(url, name) {
      if (url !== undefined && url !== null && url !== "") {
        let image = new Image();
        image.setAttribute("crossOrigin", "anonymous");
        image.src = url;
        image.onload = () => {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let ctx = canvas.getContext("2d");
          ctx.drawImage(image, 0, 0, image.width, image.height);
          canvas.toBlob((blob) => {
            let url = URL.createObjectURL(blob);
            this.download(url, name ? name : 'message-image'); // 用完释放URL对象
            URL.revokeObjectURL(url);
          });
        };
      }
    },
    download(href, name) {
      let eleLink = document.createElement("a");
      name = name === null ? 'command-image' : name;
      eleLink.download = name;
      eleLink.href = href;
      eleLink.click();
      eleLink.remove();
    },
    getTimeMethods(data) {
      const url = new URL(data).href;
      const startIndex = url.indexOf('==/');
      const endIndex = url.indexOf('?');
      const result = url.substring(startIndex + 3, endIndex);
      return result
    },
    stopAllAudioPlaying(audio, status) {
      this.setCurrentAudioData({audio, status}) 
    },
    //开始播放
    playAudio(ind) {
      if (this.interval) clearInterval(this.interval);
      let audio = [...document.querySelectorAll("#audio")];
      let audioItem = audio.findIndex(item => item.getAttribute('src') === ind);
      let currentAudio = audio[audioItem];
      // 播放
      this.stopAllAudioPlaying(this.getTimeMethods(currentAudio.getAttribute('src')), 'play')
      currentAudio.play();
      this.isTurnOnAudio = true;
      this.interval = setInterval(this.countDown, 1000);
      audio.forEach((item, index) => {
        if(index !== audioItem) {
          item.load()
        }
      })
      currentAudio.addEventListener(
        "ended",
        () => {
          this.stopAllAudioPlaying(this.getTimeMethods(currentAudio.getAttribute('src')), 'stop')
          this.isTurnOnAudio = false;
          clearInterval(this.interval);
          this.audioTime = Math.round(this.duration/1000) >= 60
                    ? 60000
                    : this.duration;
          console.log(this.audioTime,'enddaaaa')
        },
        false
      );
    },
    //暂停播放
    pause(ind) {
      let audio = [...document.querySelectorAll("#audio")];
      let audioItem = audio.findIndex((item, index) => {
        if (this.getTimeMethods(ind) == this.getTimeMethods(item.src)) {
          if(index === 0) this.fixIndex = 0
          return index;
        }
      });
      let currentAudio = audio[this.fixIndex === 0 ? 0 : audioItem];
      if(currentAudio) {
        this.stopAllAudioPlaying(this.getTimeMethods(currentAudio.getAttribute('src')), 'stop')
      }
      currentAudio.load()
      this.isTurnOnAudio = false;
      clearInterval(this.interval);
    },
    
    countDown() {
      this.audioTime = this.audioTime < 1000 ? 100 : this.audioTime - 1000;
    },
    imgOvers() {
      this.isDownImg = true;
    },
    imgOver() {
      this.isDownImg = true;
    },
    imgLeave() {
      this.isDownImg = false;
    },
    Yesterday(times) {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const today = `${year}/${month}/${day}`;
      const todayTime = new Date(today).getTime(); // 当天凌晨的时间
      const yesterdayTime = new Date(todayTime - 24 * 60 * 60 * 1000).getTime(); // 昨天凌晨的时间
      return times < todayTime && yesterdayTime <= times;
    },
    /**
     * 点击 read more 展示更多或隐藏
     */
     handleReadMore() {
      if (this.$refs.msgTextR) {
        if (this.$refs.msgTextR.style.display === "block") {
          this.$refs.msgTextR.style.display = "-webkit-box";
          this.$refs.downRowR.style.transform = "rotate(0deg)";
          this.$refs.readInfoR.innerText = "Read More";
        } else {
          this.$refs.msgTextR.style.display = "block";
          this.$refs.downRowR.style.transform = "rotate(180deg)";
          this.$refs.readInfoR.innerText = "Read Less";
        }
      }
      if (this.$refs.msgTextL) {
        if (this.$refs.msgTextL.style.display === "block") {
          this.$refs.msgTextL.style.display = "-webkit-box";
          this.$refs.downRowL.style.transform = "rotate(0deg)";
          this.$refs.readInfoL.innerText = "Read More";
        } else {
          this.$refs.msgTextL.style.display = "block";
          this.$refs.downRowL.style.transform = "rotate(180deg)";
          this.$refs.readInfoL.innerText = "Read Less";
        }
      }
    },
    /**
     * 重新发送消息
     */
    resendMsg() {
      const unsendItem = this.chatItem;
      const t = Date.now();
      const data = {
        to: this.currentSession,
        list: [{ ...unsendItem }],
      }
      this.removeUnsendMsgs(data);
      const resendMsg = {
        ...unsendItem,
        createtime: t,
        time: t
      }
      switch(this.chatItem.type) {
        case "image":
          this.sendImageMsg(resendMsg);
          break;
        case "audio":
          this.sendAudioMsg(resendMsg);
          break;
        case "text":
          this.sendTextMsg(resendMsg);
          break;
        case "custom":
          this.resendCustomMsg({ ...resendMsg, to: this.currentSession });
          break;
      }
    },
    /**
     * 图片加载判断展示
     */
     loadImg() {
      if (this.$refs.rightImg) {
          let width = this.$refs.rightImg.getBoundingClientRect().width;
          let height = this.$refs.rightImg.getBoundingClientRect().height;
          let w = 'auto';
          let h = 'auto';
          if (width < 180 && height < 180) {
            w = width;
            h = height;
          } else {
            if (width - height <= 30 || width - height >= -30) {
              w = 180;
              // h = 180;
              this.$refs.rightImg.style.objectFit = "cover";
            } else {
              if (width > height) {
                w = 240;
                this.$refs.rightImg.style.objectFit = "scale-down";
              } else {
                h = 240;
                this.$refs.rightImg.style.objectFit = "cover";
              }
            }
          }
          this.$refs.rightImg.style.width = isNaN(w) ? w : `${w}px`;
          this.$refs.rightImg.style.height = isNaN(h) ? h : `${h}px`;
        }
        if (this.$refs.leftImg) {
          let width = this.$refs.leftImg.getBoundingClientRect().width;
          let height = this.$refs.leftImg.getBoundingClientRect().height;
          let w = 'auto';
          let h = 'auto';
          if (width < 180 && height < 180) {
            w = width;
            h = height;
          } else {
            if (width - height <= 30 || width - height >= -30) {
              w = 180;
              // h = 180;
              this.$refs.leftImg.style.objectFit = "cover";
            } else {
              if (width > height) {
                w = 240;
                this.$refs.leftImg.style.objectFit = "scale-down";
              } else {
                h = 240;
                this.$refs.leftImg.style.objectFit = "cover";
              }
            }
          }
          this.$refs.leftImg.style.width = isNaN(w) ? w : `${w}px`;
          this.$refs.leftImg.style.height = isNaN(h) ? h : `${h}px`;
        }
    },
    handleAudio() {
      if (this.$props.chatItem.type !== "audio") return;
      if(this.isContinuePlaying(this.isTurnOnAudioList, this.getTimeMethods(this.$props.chatItem.file.mp3Url), 'show')) {
        this.pause(this.$props.chatItem.file.mp3Url);
      }else {
        this.playAudio(this.$props.chatItem.file.mp3Url);
      }
    },
    /**
     * 上传图片, tw 和 th是压缩后的宽高
     */
     updateImage(imgFile = null, w = 0, h = 0, tw = 0, th = 0, t) {
      if (imgFile) {
        let formData = new FormData();
        formData.append("image", imgFile);
        formData.append("width", String(tw * 2));
        formData.append("height", String(th * 2));
        imageUpload(formData).then(({ res }) => {
          // 发送图片
          this.sendImageMsg({
            ...res.data.data,
            width: w,
            height: h,
            createtime: t,
            to: this.currentSession
          })
        }).catch(() => {
          this.$message.error("Failed to send message.");
          this.messageSendError({
            to: this.currentSession,
            createtime: t,
          });
        });
        this.srollBottom(true);
      }
    },
    sendInfo(data) {
      data = data.trim();
      if (data) {
        this.sendTextMsg({
          text: data,
          to: this.currentSession,
          createtime: Date.now()
        });
      }
      this.content = "";
      this.srollBottom(true);
    },
  },
}